import React, { useEffect } from 'react';
import Tabs from 'antd/lib/tabs';
import queryString from 'query-string';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { AlertsOverview } from './components/AlertsOverview';
import { AlertDetails } from './components/AlertDetails';
import { AlertsPreferences } from './components/AlertsPreferences';

import './AlertsPage.less';

export const AlertsPage = (props) => {
  const { theme, buildings, buildingName } = props;
  const { TabPane } = Tabs;
  const history = useHistory();
  const { building: buildingId } = useParams();
  const { search } = useLocation();
  const { incident_id } = queryString.parse(search);
  const { event_id } = queryString.parse(search);
  const { tab } = queryString.parse(search);

  const activeBuilding = buildings.find(b => b.identifier === buildingId)


  useEffect(() => {
    if (!tab && !incident_id && !event_id) {
      history.replace(`/alerts/${buildingId}?tab=Overview`);
    }
  }, [search]);

  useEffect(() => {
    if (buildings.length > 0) {
      const sessionSelectedBuilding = JSON.parse(sessionStorage.getItem('selectedBuilding') || '{}');

      window.document.title = `${sessionSelectedBuilding.name || 'Parity Alerts'} | ${
        incident_id && event_id ? 'Alert Details' : 'Alerts Overview'
      }`;
    }
  }, [buildings, buildingId]);

  const changeTab = (activeKey) => {
    history.push(`/alerts/${buildingId}?tab=${activeKey}`);
  };

  const getDefaultActiveKey = () => {
    return tab;
  };

  return (
    <>
      {incident_id && event_id ? (
        <AlertDetails theme={theme} buildingName={buildingName} isSupervisor={activeBuilding.is_supervisor} />
      ) : (
        <div className="alerts-page">
          <div className="alerts-page-header">
            <div className="alerts-page-title">Alerts</div>
            <Tabs
              className={`alerts-tabs app-tabs-${theme}`}
              defaultActiveKey={getDefaultActiveKey()}
              onChange={(activeKey) => changeTab(activeKey)}
            >
              <TabPane tab="Overview" key="Overview">
                <AlertsOverview theme={theme} />
              </TabPane>
              <TabPane tab="Preferences" key="Preferences">
                <AlertsPreferences theme={theme} buildings={buildings} />
              </TabPane>
            </Tabs>
          </div>
        </div>
      )}
    </>
  );
};
